import { store } from "../app/store";

export default function Can(permissions) {
  const { user } = store.getState().profile;
  if (!user) {
    return false;
  }
  // const { role } = user.info;
  // if (!role) {
  //   return false;
  // }
  const { permissions: userPermissions } = user.info;
  if (!userPermissions) {
    return false;
  }
  if (Array.isArray(permissions)) {
    return permissions.some((p) => userPermissions.includes(p));
  }
  return userPermissions.includes(permissions);
}
